import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a959735"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "revenue" };
const _hoisted_2 = { class: "revenue__header" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = { class: "revenue__title" };
const _hoisted_5 = { class: "revenue__total" };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "revenue__sign" }, "R$", -1));
const _hoisted_7 = { class: "revenue__highlight" };
const _hoisted_8 = { class: "revenue__description" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon icon-question-12px" }, null, -1));
const _hoisted_10 = { class: "progress-container" };
const _hoisted_11 = { class: "revenue__indicators" };
const _hoisted_12 = { class: "revenue__caption" };
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "revenue__caption--dot" }, null, -1));
const _hoisted_14 = { class: "revenue__caption" };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "revenue__caption--dot revenue__caption--dot-highlight" }, null, -1));
import { formatDecimal, formatPercent } from '@/utilities/formatters';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AttributedRevenue',
    props: {
        impactValues: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("img", {
                        src: require(`@/assets/img/icons/welcome/smile.svg`),
                        alt: _ctx.$t('welcome.oto-impact.header-icon')
                    }, null, 8, _hoisted_3),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(props.impactValues.revenueOto?.name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("p", null, [
                        _hoisted_6,
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(formatDecimal)(props.impactValues.revenueOto?.value, 0) || 0), 1),
                        _createElementVNode("span", _hoisted_8, [
                            _createTextVNode(_toDisplayString(_ctx.$t('welcome.oto-impact.total-brand-revenue')) + " " + _toDisplayString(_unref(formatDecimal)(props.impactValues.revenueBrand?.value, 0) || 0) + " ", 1),
                            _createVNode(_component_el_tooltip, {
                                content: props.impactValues.revenueBrand?.tooltip,
                                placement: "bottom",
                                style: { "width": "2px" },
                                "popper-class": "oto-impact__revenue"
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_9
                                ]),
                                _: 1
                            }, 8, ["content"])
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                        class: "progress-bar",
                        style: _normalizeStyle({
                            width: _unref(formatPercent)(props.impactValues.revenueOto?.value / props.impactValues.revenueBrand?.value),
                        })
                    }, null, 4)
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('welcome.oto-impact.general-revenue')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('welcome.oto-impact.oto-influence')), 1)
                    ])
                ])
            ]));
        };
    }
});
